import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { Hospital } from 'types/hospital';

type HospitalItemModuleProps = {
  hospital: Hospital;
};

const HospitalItemModule: React.FC<HospitalItemModuleProps> = ({ hospital }) => {
  return (
    <ModuleCard
      idLabel={`ID ${hospital.id}`}
      title={hospital.company_name}
      subtitle={hospital.company_trade_name}
      status={hospital.formattedActive}
      statusTone={hospital.active ? 'success' : 'error'}
      fields={[
        { label: 'CNPJ', value: hospital.document_number },
        { label: 'E-mail', value: hospital.email },
        { label: 'Telefone', value: hospital.phone },
        { label: 'Endereço', value: hospital.formattedStreet },
        { label: 'Cidade/UF', value: [hospital.formattedCity, hospital.formattedState].filter(Boolean).join(' - ') },
      ]}
      onClick={() => history.push(`/hospitals/${hospital.id}`)}
    />
  );
};

export default HospitalItemModule;
